enum PerfisAtendente {
    Administrador = 1,
    Atendente = 2,
}

export default PerfisAtendente;
